module.exports = __webpack_public_path__ + "media/country_flags/cz-31bde4dd.png";